// Code generated by protoc-gen-weave-ts. DO NOT EDIT.
import * as fm from "../../../fetch.pb.js";
/**
 * Enum for Stripe Client Type
 */
export var PayoutsRequest_StripeClientType;
(function (PayoutsRequest_StripeClientType) {
    PayoutsRequest_StripeClientType["STRIPE_CLIENT_TYPE_UNSPECIFIED"] = "STRIPE_CLIENT_TYPE_UNSPECIFIED";
    PayoutsRequest_StripeClientType["TEST"] = "TEST";
    PayoutsRequest_StripeClientType["LIVE"] = "LIVE";
})(PayoutsRequest_StripeClientType || (PayoutsRequest_StripeClientType = {}));
export var PayoutsRequest_StripeClientType_index;
(function (PayoutsRequest_StripeClientType_index) {
    PayoutsRequest_StripeClientType_index[PayoutsRequest_StripeClientType_index["STRIPE_CLIENT_TYPE_UNSPECIFIED"] = 0] = "STRIPE_CLIENT_TYPE_UNSPECIFIED";
    PayoutsRequest_StripeClientType_index[PayoutsRequest_StripeClientType_index["TEST"] = 1] = "TEST";
    PayoutsRequest_StripeClientType_index[PayoutsRequest_StripeClientType_index["LIVE"] = 2] = "LIVE";
})(PayoutsRequest_StripeClientType_index || (PayoutsRequest_StripeClientType_index = {}));
export const StripeIntegration = {
    GetPayoutDescriptor(fn, req) {
        return fn(`/payments-platform/stripe-integration/payout-descriptors`, { method: "POST", body: JSON.stringify(req, fm.replacer) });
    },
};
